import { useTranslation } from 'react-i18next';
import { CashAccountFormSideOverPageProps } from './types';
import { displayCashAccountType, StandardCashAccountForm } from '../../../CashAccount';
import { ElementsButton, SideOverFooter, SideOverHeaderNew, SideOverHeading } from '../../components';
import { useWindowSize } from 'react-use';
import { MDTailwindMinPixelBreakpointWidth } from '../../../util';

export function CashAccountFormSideOverPage({
  exit,
  firmID,
  clientID,
  isLoading,
  allowDocuments,
  cashAccountType,
  useCashAccountFormReturn,
}: CashAccountFormSideOverPageProps) {
  const { width: windowWidth } = useWindowSize();
  const { t: tCommon } = useTranslation('common');
  const { t: tCashAccount } = useTranslation('cashAccount');

  return (
    <>

      <SideOverHeaderNew exit={exit} withShadow className="!px-4" exitText={tCommon('cancel')} />
      <div className="md:px-10 px-4">

        {cashAccountType && <SideOverHeading heading={displayCashAccountType(cashAccountType, tCashAccount)} />}
        {useCashAccountFormReturn.formReady && (
          <StandardCashAccountForm
            firmID={firmID}
            clientID={clientID}
            className="mb-28 md:mb-36"
            useCashAccountFormReturn={useCashAccountFormReturn}
            visibilityOptions={{ hideFileList: !allowDocuments, hideCreateFileInput: !allowDocuments }}
          >
            <SideOverFooter>
              <ElementsButton
                icon="check"
                iconPosition="left"
                isLoading={isLoading}
                label={tCommon('save')}
                size={windowWidth < MDTailwindMinPixelBreakpointWidth ? 'small' : 'large'}
              />
            </SideOverFooter>
          </StandardCashAccountForm>
        )}
      </div>
    </>
  );
}
